
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 38 38","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"transform":"translate(1 1)","stroke":"#111","stroke-width":"2","fill":"none","fill-rule":"evenodd","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('circle',{attrs:{"cx":"12.818","cy":"10","r":"4"}}),_c('path',{staticClass:"fill",attrs:{"d":"M25.364 14L36 27l-1.04 8.051-15.47.893.015.056-.962-.001-.017.001v-.001L4.903 36l-3.313-.984L0 31.744 9.818 21l5.604 6.163L25.364 14z","fill":"#000"}}),_c('path',{attrs:{"d":"M2 0h32a2 2 0 012 2v32a2 2 0 01-2 2H2a2 2 0 01-2-2V2a2 2 0 012-2z"}})])])
          )
        }
      }
    